module.exports = __webpack_public_path__ + "static/media/4.93f7f477.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/4.png
// module id = 1264
// module chunks = 0